import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";
import { requesterDetailsFormState } from "../../../features/CaptureDetailsSlice";
import EmailFieldComponent from "../../FormComponents/EmailField/EmailFieldComponent";
import PhoneFieldComponent from "../../FormComponents/PhoneField/PhoneFieldComponent";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { invalidAlternativeNumber } from "../FormValidationHelper";

const EmailPhoneDetails = () => {
  const captureDetailsForm = useSelector(requesterDetailsFormState);

  const matches = useMediaQuery("(max-width:900px)");

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
        <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
          flex: "0 0 100%",
        }})}>
          <EmailFieldComponent
            id="email-address"
            label="Email Address"
            name="emailAddress"
            required={true}
          />
        </Box>

        <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
          flex: "0 0 100%",
        }})}>
          <PhoneFieldComponent
            id="mobile-number"
            label="Mobile Number"
            name="mobileNumber"
            required={true}
          />
        </Box>

        {!matches ? (
          <>
            <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
                flex: "0 0 100%",
              }})}>
                <PhoneFieldComponent
                  id="alternative-number"
                  label="Alternative Number"
                  name="alternativeNumber"
                  required={false}
                />
            </Box>

            <Box sx={(theme) => ({ flex: "0 0 49%", justifyContent: 'flex-start', alignItems: 'center', display: 'flex', [theme.breakpoints.down('sm')]: {
                flex: "0 0 100%",
              }})}>
                <Tooltip
                  title="This phone number is different to your default mobile number, and can be used to contact you in the event that your primary mobile number is unavailable."
                  placement="right"
                >
                  <IconButton>
                    <InfoOutlinedIcon color="primary" />
                  </IconButton>
                </Tooltip>
            </Box>
          </>
        ) : (
          <Box sx={(theme) => ({ flex: "0 0 49%", [theme.breakpoints.down('sm')]: {
            flex: "0 0 100%",
          }})}>
            <Box sx={{ display: "flex" }}>
              <PhoneFieldComponent
                id="alternative-number"
                label="Alternative Number"
                name="alternativeNumber"
                required={false}
              />
              <Tooltip
                title="This phone number is different to your default mobile number, and can be used to contact you in the event that your primary mobile number is unavailable."
                placement="right"
              >
                <IconButton>
                  <InfoOutlinedIcon color="primary" sx={{ ml: "8px" }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        )}
      </Box>

      {invalidAlternativeNumber(captureDetailsForm) && captureDetailsForm?.valid ? (
        <Typography
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: "0.75rem",
            ml: "2px",
            mt: "4px",
          })}
        >
          The alternative number must be different to the mobile number
        </Typography>
      ) : null}
    </>
  );
};

export default EmailPhoneDetails;
